// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .legal-list {
    list-style: none;
    padding-left: 0;
    margin: 0;
  }
  
  .legal-list-item {
    margin-bottom: 1em; 
    position: relative;
    padding-left: 1em; 
  }
  
  .legal-list-item::before {
    content: "-";
    position: absolute;
    left: 0;
  }`, "",{"version":3,"sources":["webpack://./src/utils/AccessibleLegalContent.css"],"names":[],"mappings":";EACE;IACE,gBAAgB;IAChB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,OAAO;EACT","sourcesContent":["\n  .legal-list {\n    list-style: none;\n    padding-left: 0;\n    margin: 0;\n  }\n  \n  .legal-list-item {\n    margin-bottom: 1em; \n    position: relative;\n    padding-left: 1em; \n  }\n  \n  .legal-list-item::before {\n    content: \"-\";\n    position: absolute;\n    left: 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
